<template>
  <v-dialog :key="data.dialogphone" v-model="data.dialogphone" width="900">
    <template v-slot:activator="{ on, attrs }">
      <v-card class="py-4" elevation="0" v-bind="attrs" v-on="on">
        <v-row>
          <v-col cols="1"
            ><v-icon color="secondary">fal fa-phone-rotary</v-icon>
          </v-col>
          <v-col cols="9">{{ data.phonenumber }} </v-col>
          <v-col cols="1" class="text-right">
            <v-icon color="dark">fal fa-pencil</v-icon>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <v-card elevation="0" class="rounded-lg pa-5">
      <v-html class="overline">Telefoonnummer wijzigen</v-html>
                <v-spacer class="py-4"></v-spacer>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="data.phonenumber"
                      label="Telefoonnummer"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
      <v-row>
        <v-col cols="12" class="ml-auto text-right">
          <v-btn
            color="default"
            right
            to="/my-details"
            class="mr-3"
            elevation="0"
          >
            Annuleren
          </v-btn>
          <v-btn color="secondary" right @click="submit" elevation="0">
            Opslaan
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    data: Object,
  },
};
</script>

